document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.js-banner');
  const button = banner?.querySelector('button');
  const campaign = banner?.dataset.campaign || 'banner';

  function setCookie(name, value, seconds) {
    const d = new Date();
    d.setTime(d.getTime() + seconds * 1000);
    document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  if (banner && button) {
    const delay = parseFloat(banner.dataset.delay);

    if (getCookie(`banner_${campaign}`)) return;

    banner.style.display = 'block';

    button.addEventListener('click', () => {
      if (!isNaN(delay)) {
        banner.style.display = 'none';
        setCookie(`banner_${campaign}`, 'closed', delay);
      }
    });
  }
});
